import {Button} from '@hm/fundamental'
import {mdiRefresh} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

import type {DraftRange} from './RefractoryAdvancedFilters.types'

interface RefractoryFilterResetButtonProps {
  name: string
  label: string
  range: DraftRange
  onReset: () => void
}

export const RefractoryFilterResetButton: React.FC<RefractoryFilterResetButtonProps> = ({
  name,
  label,
  range,
  onReset
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return range.min.trim() || range.max.trim() ? (
    <Button
      type="button"
      variant="tertiary"
      size="large"
      square
      icon={mdiRefresh}
      aria-label={t('refraCatalog.filters.resetField', {field: label})}
      data-cy={`refra-catalog-reset-${name}`}
      onClick={onReset}
    />
  ) : (
    <span />
  )
}
